import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';

export default class OrderView extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            isMy: props.IsMy,
            caller: props.Caller,
            data: null,
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    Settlement() {
        this.httpPost("api/v1/orderview/settlement", {
            id: this.state.data.record.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("تسویه با موفقیت ثبت شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/orderview/get", {
            id: this.getCurrentFormId(),
            isMy: this.state.isMy
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
                <div className="modal-dialog ui-draggable">
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">
                                جزئیات سفارش و فروش
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                            <label for="name" className="title1">موضوع: {this.state.data.record.typeString}</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                            <label for="name" className="title1">وضعیت: {this.state.data.record.statusString}</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                            <label for="name" className="title1">تاریخ: {this.state.data.record.date}</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                            <label for="name" className="title1">جمع سفارش: {this.money(this.state.data.record.final)}</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                            <label for="name" className="title1">کمیسیون: {this.money(this.state.data.record.commision)}</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                            <label for="name" className="title1">فروشنده: {this.state.data.record.sellerUserName}</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                            <label for="name" className="title1">خریدار: {this.state.data.record.buyerUserName}</label>
                                            </div>
                                    </div>
                                    
                                </div>

                                <h5 className="card-title">اقلام سفارش</h5>
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text">شرح</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">تعداد</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">قیمت</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">هزینه پست</span></div>
                                        </div>
                                        {this.state.data.items.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{(index + 1)}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text">{record.itemDescription}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{record.count}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{this.money(record.price)}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{this.money(record.postPrice)}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <h5 className="card-title">پرداختهای سفارش</h5>
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">رسید فروشنده</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">رسید خریدار</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">شماره کارت</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">درگاه</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">وضعیت</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">تاریخ</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">مبلغ</span></div>
                                        </div>
                                        {this.state.data.transactions.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{(index + 1)}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{record.refId}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{record.resId}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{record.cardHolderPan}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{record.gatewayString}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{record.stateString}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{record.dateString}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{this.money(record.price)}</span>
                                                </div>                                                
                                            </div>
                                        )}
                                    </div>
                                </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>برگشت</button>
                            {!this.state.isMy && this.state.data.record.status === 2 && <button type="button" className="btn btn-success" onClick={e => this.Settlement()}>تسویه با فروشنده</button>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}